import {Aseprite} from '@theatrejs/plugin-aseprite';import data from './king.json';import texture from './king.png';export default new Aseprite(texture, data);